/**
 * Feature hook: Login state + login thunks (authAPI). Do not use Redux state or dispatch directly in components.
 */
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  fetchAzureToken,
  fetchUserValidation,
  fetchIfsToken,
  runAuthFlow,
  retryLogin,
  logoutUser,
} from "../slices/login/loginThunks";

export function useLogin() {
  const dispatch = useAppDispatch();
  const loginState = useAppSelector((state) => state.Login);

  const onStartUpAction = useCallback(() => dispatch(runAuthFlow()), [dispatch]);
  const onAzureTokenRequestAction = useCallback(
    (refreshToken = true) => dispatch(fetchAzureToken(refreshToken)),
    [dispatch]
  );
  const onIfsUserValidateAction = useCallback(
    () => dispatch(fetchUserValidation()),
    [dispatch]
  );
  const onIfsUserLoginAction = useCallback(
    (refreshToken = true, preAction) =>
      dispatch(fetchIfsToken({ refreshToken, preAction })),
    [dispatch]
  );
  const onLogoutAction = useCallback(() => dispatch(logoutUser()), [dispatch]);
  const onRetryAction = useCallback(
    (dataLoadStatus) => dispatch(retryLogin(dataLoadStatus)),
    [dispatch]
  );

  return {
    userInfo: loginState.userInfo,
    tokenInfo: loginState.tokenInfo,
    teamsContext: loginState.teamsContext,
    tokenRefreshPreAction: loginState.tokenRefreshPreAction,
    onStartUp: onStartUpAction,
    onAzureTokenRequest: onAzureTokenRequestAction,
    onIfsUserValidate: onIfsUserValidateAction,
    onIfsUserLogin: onIfsUserLoginAction,
    onRetry: onRetryAction,
    onLogout: onLogoutAction,
  };
}
